export enum ApiHeaderType {
    json,
    blob,
    formData,
}